import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import qs from 'qs'
import { useHistory, useLocation, Redirect } from 'react-router-dom'

const Policy = ({ t }) => {
    const location = useLocation()
    const history = useHistory()

    const [authorPolicy, setAuthorPolicy] = useState(void 0)

    useEffect(() => {
        if (window.location.search.length) {
            history.push({
                pathname: window.location.pathname,
                state: {
                    from: {
                        pathname: window.location.origin + window.location.pathname,
                        search: window.location.search,
                    },
                },
            })
        }

        if (location.state && location.state.from && location.state.from.search) {
            const { authorPolicy } = qs.parse(location.state.from.search, { ignoreQueryPrefix: true })

            if (authorPolicy) setAuthorPolicy(authorPolicy.includes('://') ? authorPolicy : `//${authorPolicy}`)
        }
    }, [location])

    return (
        <div className="policy">
            <h1>{t('_pages._policy.title')}</h1>
            <p>{t('_pages._policy.text_1')}</p>
            <a href="/privacy-policy">{t('_pages._policy.interacty_privacy_policy')}</a>
            <a href="/data-processing-agreement">{t('_pages._data_processing_agreement.title')}</a>
            {authorPolicy !== void 0 ? (
                <a href={authorPolicy}>Project author’s Privacy Policy</a>
            ) : (
                <span>
                    {t('_pages._policy.author_privacy_policy')}
                    <br />
                    {t('_common.not_specified')}
                </span>
            )}
        </div>
    )
}

export default withTranslation('translations')(Policy)
